// 全局组件统一引入注册
import ComButton from '@/components/comButton/index.vue'  // 按钮组件
import ComHeadToolBar from '@/components/comHeadToolBar/index.vue'   // 头部工具栏组件
import SwipeComponents from '@/components/SwipeComponents/index.vue'   // 轮播图组件
import NoticeComponents from '@/components/NoticeComponents/index.vue'   // 公告组件
import ComInput from "@/components/comInput/index.vue" //充值，提现输入框
import ComShowIcon from "@/components/comShowIcon/index.vue"//充值提现的金钱显示卡片
import ComSelBtn from "@/components/comSelBtn/index.vue"//选择收入或者支出的按钮
import ComFoldPanel from "@/components/comFoldPanel/index.vue" //多级折叠面板
import ComPopup from '@/components/comPopup/index.vue'   // 弹窗组件
import PopupCustom from '@/components/PopupCustom/index.vue'   // 弹窗组件NEW
import ComList from '@/components/comList/index.vue'   // 列表组件
import ComStatusBarCard from '@/components/comStatusBarCard/index.vue'   // 状态栏组件
import ComPropertyListCard from '@/components/comPropertyListCard/index.vue'   // 键值对列表卡片组件
import ComLanguagePopup from '@/components/comLanguagePopup/index.vue'   // 语言选择弹窗组件
import ComListLoad from '@/components/comListLoad/index.vue'   // 列表加载组件

import ComGrid from '@/components/comGrid/index.vue'  //首页宫格组件带图
import IndexComponents from '@/components/IndexComponents/index.vue'  // 首页组件
import ComAddress from '@/components/comAddress/index.vue'  // 地址组件
import ComInvite from '@/components/comInvite/index.vue'  // 邀请
import ComInvitationlink from '@/components/comInvitationlink/index.vue'  //邀请有礼邀请链接
import ComLoading from '@/components/comLoading/index.vue'  //loading组件
import TianshengButton from '@/components/TianshengButton/index.vue'  //天晟按钮
import TianshengCarousel from '@/components/TianshengCarousel/index.vue'  //天晟轮播
import TianshengPopup from '@/components/TianshengPopup/index.vue'  //天晟弹窗

const components = {
    ComButton,
    ComHeadToolBar,
    ComInput,
    ComShowIcon,
    ComSelBtn,
    ComFoldPanel,
    SwipeComponents,
    NoticeComponents,
    ComPopup,
    PopupCustom,
    ComGrid,
    IndexComponents,
    ComList,
    ComStatusBarCard,
    ComPropertyListCard,
    ComAddress,
    ComLanguagePopup,
    ComInvite,
    ComInvitationlink,
    ComListLoad,
    ComLoading,
    TianshengButton,
    TianshengCarousel,
    TianshengPopup

}

export default {
    install(Vue) {
        Object.keys(components).forEach(key => {
            Vue.component(key, components[key])
        })
    }
}